import queryString from 'query-string';

export const getQString = (search) => {
  const parsed = queryString.parse(search);
  const params = [];

  if (parsed.wineType) {
    params.push(`wineType=${parsed.wineType}`);
  }
  if (parsed.wineVarietal) {
    params.push(`wineVarietal=${parsed.wineVarietal}`);
  }
  if (parsed.wineCountryCode) {
    params.push(`wineCountryCode=${parsed.wineCountryCode}`);
  }
  if (parsed.wineRegion) {
    params.push(`wineRegion=${parsed.wineRegion}`);
  }
  if (parsed.wineVintage) {
    params.push(`wineVintage=${parsed.wineVintage}`);
  }
  if (parsed.wineAppellation) {
    params.push(`wineAppellation=${parsed.wineAppellation}`);
  }
  if (parsed.vendorId) {
    params.push(`vendorId=${parsed.vendorId}`);
  }
  if (parsed.fromPrice) {
    params.push(`fromPrice=${parsed.fromPrice}`);
  }
  if (parsed.toPrice) {
    params.push(`toPrice=${parsed.toPrice}`);
  }

  if (params.length === 0) {
    return undefined;
  }

  return params.join('&');
};

export const getWineTasteProfileScore = (tasteProfileScore) => {
  if (!tasteProfileScore) {
    return null;
  }

  const scoreValue = parseInt(tasteProfileScore, 10);
  const circles = [];

  for (let i = 1; i <= 5; i++) {
    const circleClass =
      i <= scoreValue ? 'c7-taste-circle--filled' : 'c7-taste-circle--empty';
    circles.push(
      <span
        key={i}
        className={`c7-taste-circle ${circleClass}`}
        aria-hidden="true"
      />
    );
  }

  return (
    <div className="c7-taste-profile-score">
      {circles}
      <span className="c7-sr-only">{`${scoreValue} out of 5`}</span>
    </div>
  );
};
